'use strict';

export default class VideoBox {
	constructor(element, sp) {
		this.root = element.getElementsByClassName("PenaltyVideo__box")[0];
		this.videoContainer = this.root.getElementsByClassName("PenaltyVideo__video")[0];

		this.spMode = sp;
		if (this.spMode) {
			this.texts = this.root.getElementsByClassName("PenaltyVideo__txt");
		}

		let listContainer = this.root.getElementsByClassName("PenaltyVideo__list")[0];
		this.list = listContainer.getElementsByTagName("li");

		for (let i = 0; i < this.list.length; i++) {
			this.list[i].addEventListener("click", event => this.changeVideo(i));
		}

		this.changeVideo(0);
	}

	changeVideo(index) {
		let id = this.list[index].getAttribute("data-youtube-id");

		for (let i = 0; i < this.list.length; i++) {
			this.list[i].classList.remove("-current");

			if (this.spMode) {
				this.texts[i].classList.remove("-current");
			}
		}

		this.videoContainer.textContent = null;
		this.videoContainer.appendChild(this.createVideo(id));

		this.list[index].classList.add("-current");

		if (this.spMode) {
			this.texts[index].classList.add("-current");
		}
	}

	createVideo(id) {
		let video = document.createElement('iframe');
		video.setAttribute("width", '100%');
		video.setAttribute("height", '100%');
		video.setAttribute("src", "https://www.youtube.com/embed/" + id + "?rel=0&amp;controls=1&amp;showinfo=0");
		video.setAttribute("frameborder", 0);
		video.setAttribute("allowfullscreen", "allowfullscreen");

		return video;
	}
}


// WEBPACK FOOTER //
// ./assets/js/VideoBox.js